import React, {Component } from 'react';
import Navbar from './mycomponents/navbar';
import ReferPeopleBody from './mycomponents/referpeoplebody';
import { withRouter } from "react-router";

class ReferPeople extends Component {
    state = {  } ;
   
   
    render() { 
        const course = decodeURI(window.location.href.split('/')[4]);
        const user= this.props.user;
        return (
            <React.Fragment>
            <Navbar/>
            <ReferPeopleBody course={course}  user={user} charge={this.props.charge}/>
            </React.Fragment>
        );
    }
}
 
export default ReferPeople;